<template>
<ul>
  <template v-for="(item, index) in circles">
    <li v-if="!item.choice" class="clear" :class="{'black':color}"
        @mouseenter="enter(index)" @mouseleave="leave(index)" @click="choiceCir(index)">
      <span class="cir-name" v-show="item.choice">{{item.name}}</span>
      <span class="normal"></span>
    </li>
    <li v-else class="clear" :class="{'black':item.black}">
      <span class="cir-name" v-show="item.choice">{{item.name}}</span>
      <span class="normal choice"></span>
    </li>
  </template>


</ul>
</template>

<script>
    export default {
      name: "circular",
      props: ['circles','color'],
      mounted(){
      },
      methods: {
        choiceCir(index) {
          this.$emit("update:showIndex",index);
        },
        enter(index) {
            document.getElementsByClassName('cir-name')[index].style.display = 'inline-block';
        },
        leave(index) {
          document.getElementsByClassName('cir-name')[index].style.display = 'none';
        }
      }
    }
</script>

<style lang="less" scoped>
  li {
    width: 100%;
    cursor: pointer;
    height: 30px;
    height: 30px;
    line-height: 30px;
    margin-bottom: 8px;
    text-align: right;
    color: white;
    font-size: 1.35rem;
  }
  .black{
    color: #333333;
    .choice {
      border: 2px solid #333333;
    }
  }
  .cir-name {
    display: block;
    float: left;
    width: 78px;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-top: 2px;
  }
  .normal{
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #999999;
    cursor: pointer;
    vertical-align: middle;
    margin-right: 7px;
  }
  .choice {
    width: 16px;
    height: 16px;
    margin-right: 0;
    border-radius: 50%;
    border: 2px solid white;
    background-color: transparent;
    @media screen and (max-width: 1500px) {
      width: 14px;
      height: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/plug/Circular.vue